import { Awaitable } from 'utils/hooks/globalState/util';
import { useCyclesAwaitable } from 'utils/hooks/globalState/useCycles';
import { Cycle } from 'types/Cycle';

import { GlobalState } from './GlobalState';

const getCurrentCycle = (cycles: Cycle[]) =>
  cycles.find(cycle => cycle.current);

export const useInitialiseGlobalStateAwaitable: () => Awaitable<GlobalState> =
  () => {
    const cyclesAwaitable = useCyclesAwaitable();
    if (cyclesAwaitable.loading === true) {
      return { loading: true };
    }
    return {
      loading: false,
      data: {
        selectedCycle: getCurrentCycle(cyclesAwaitable.data),
        isCyclePinned: false,
      },
    };
  };
